import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-100/60 border-t border-background-300/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line"></i>
              </span>
              <span className="text-base font-heading font-bold text-foreground-900 whitespace-nowrap">
                伦理剧精选
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              感动人心的家庭情感故事汇聚之地。
              我们致力于为观众筛选最优质的伦理剧作品，
              提供深度的剧情解析与温暖的观影陪伴。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-4">
              剧集分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/category/jingdian-lunli"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  经典重温
                </Link>
              </li>
              <li>
                <Link
                  to="/category/guochan-lunli"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  国产伦理
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@lunliju.example.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-wechat-line text-primary-500"></i>
                <span>伦理剧精选</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-weibo-line text-primary-500"></i>
                <span>@伦理剧精选</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 伦理剧精选. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              网站地图
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}